/*=========================================================================================
File Name: getters.js
Description: Vuex Store - getters
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

const getters = {

	// COMPONENT
	// vx-autosuggest
	// starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
	windowBreakPoint: state => {

		// This should be same as tailwind. So, it stays in sync with tailwind utility classes
		if (state.windowWidth >= 1200) return "xl"
		else if (state.windowWidth >= 992) return "lg"
		else if (state.windowWidth >= 768) return "md"
		else if (state.windowWidth >= 576) return "sm"
		else return "xs"
	},

	scrollbarTag: state => {
		return state.is_touch_device ? 'div' : 'VuePerfectScrollbar'
	},
	// ////////////////////////////////////////////
	// CUSTOM
	// ////////////////////////////////////////////

	getListingCount: state => {
		return state.listingCount;
	},
	getTableFilterValue: state => {
		return state.tableFilter['value'];
	},
	getTableFilterOptions: state => {
		return state.tableFilter['options'];
	},
	getTableFilterActive: state => {
		return state.tableFilter['active'];
	},
	getTakedownDomains: state => {
		return state.takedownDomains;
	},
	getBlacklistedKeywords: state => {
		return state.blacklistedKeywords;
	},

	getSwitchToTab: state => {
		return state.switchToTab;
	},

	// NOTE: Master data getters
	getCountries: state => {
		return state.countries;
	},
	getCurrencies: state => {
		return state.currencies;
	},
	getTlds: state => {
		return state.tlds;
	},
	getRegistrars: state => {
		return state.registrars;
	},
	getCustomUniqueRegistrars: state => {
		return state.customUniqueRegistrars;
	},
	getResellers: state => {
		return state.resellers;
	},
	getGroups: state => {
		return state.groups;
	},
	getPromoTags: state => {
		return state.promoTags;
	},
	getCustomTags: state => {
		return state.customTags;
	},
	getUsers: state => {
		return state.users;
	},
	getAMs: state => {
		return state.ams;
	},
	getRoles: state => {
		return state.roles.map(x => {
			return {
				label: x.name,
				value: x.id
			}
		});
	},
	// Helper functions for master data
	formGroups: state => {
		let groupArray = state.groups.map((x) => {
			return {
				label: x["name"],
				value: x["id"],
				type: x["type"],
				new_registrar_group: x["new_registrar_group"],
				new_reseller_group: x["new_reseller_group"],
			};
		});
		return groupArray;
	},

	formResellers: state => {
		let resellerArray = state.resellers.map((x) => {
			return {
				label: x["name"],
				value: x["id"],
			};
		});

		return resellerArray;
	},

	formRegs: state => {
		let registrarArray = state.registrars.map((x) => {
			return {
				label: x["name"],
				value: x["id"],
			};
		});

		return registrarArray;
	},
	formCurrencies: state => {
		let CurrencyArray = state.currencies.map((x) => {
			return {
				label: x["name"] + "  -  " + x["sign"],
				value: x["id"],
				sign: x["sign"],
			};
		});

		return CurrencyArray;
	},

	formTlds: state => {
		let tldArray = state.tlds.map((x) => {
			return {
				label: x["tld_name"],
				value: x["id"],
				name: x["tld_name"],
			};
		});

		return tldArray;
	},

	formPromoTags: state => {
		let promoTagArray = state.promoTags.map((x) => {
			return {
				label: x["tag_name"],
				value: x["id"],
			};
		});

		return promoTagArray;
	},

	formCustomTags: state => {
		let customTagArray = state.customTags.map((x) => {
			return {
				label: x["tag_name"],
				value: x["id"],
			};
		});

		// return [
		// 	{
		// 		label: "NA",
		// 		value: null,
		// 	},
		// 	...customTagArray,
		// ];

		return customTagArray;
	},

	formGeo: state => {
		let GeoCurrencyArray = state.countries.map((x) => {
			return {
				label: x["name"],
				value: x["id"],
			};
		});

		// return GeoCurrencyArray;
		return [
			{
				label: "NA",
				value: null,
			},
			...GeoCurrencyArray,
		];
	},

	formUsers : state => {
		let userArray = [{
			label : "Select",
			value: null
		}]

		state.users.map(x => {
			userArray.push({
				label: x.name,
				value: x.id
			})
		})

		return userArray;
	},

	formAMs : state => {
		let userArray = [{
			label : "Select",
			value: null
		}]

		state.ams.map(x => {
			userArray.push({
				label: x.name,
				value: x.id
			})
		})

		return userArray;
	},

	formTucowsOnboardingRegistrars: state => {
		return state.tucowsOnboardingRegistrars.map(x => {
			return {
				label: x.name,
				value: x.id,
				iana_id: x.iana_id
			}
		});
	},

	getClientOptions: state => {
		return state.clientOptions;
	},
	
	getClientRebateStatus: state => {
		return state.clientRebateStatus;
	},
	getClientToken: state => {
		return state.clientToken;
	},

	getDisableCNICFlag: state => {
		return state.disableCNICFlag;
	}
}

export default getters
